import * as React from 'react';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { SessionContext } from '../../context/Session';

export default function Review({ total, tax }) {
  const { purchaseItem } = React.useContext(SessionContext);
  const { name, description, type, size, texture, top_coat, shey_description } =
    purchaseItem;
  const products = [
    {
      name: purchaseItem.name,
      type: `${type.toUpperCase()}, ${size}, ${top_coat.toUpperCase()}, ${texture.toUpperCase()}`,
      desc: description,
      sheyDescription: shey_description,
      price: `$${parseInt(purchaseItem.price).toFixed(2)}`,
    },
    { name: 'Tax', type: 'Tax', desc: '', price: `$${tax}` },
    {
      type: 'Shipping',
      name: 'Shipping',
      desc: '',
      price: `${
        purchaseItem.shipping
          ? '$' + parseInt(purchaseItem.shipping).toFixed(2)
          : 'FREE'
      }`,
    },
  ];

  if (shey_description) {
    return (
      <React.Fragment>
        <Typography variant='primary' gutterBottom>
          Order summary
        </Typography>
        <List disablePadding>
          <ListItem sx={{ py: 1, px: 0 }}>
            <ListItemText
              primary={'Custom Order Description'}
              secondary={products[0].desc}
            />
          </ListItem>
          <ListItem sx={{ py: 1, px: 0 }}>
            <ListItemText
              primary={'From Shey'}
              secondary={products[0].sheyDescription}
            />
          </ListItem>
          {products.map((product) => (
            <ListItem key={product.name} sx={{ py: 1, px: 0 }}>
              <ListItemText primary={product.type} />
              <Typography variant='body2'>{product.price}</Typography>
            </ListItem>
          ))}
          <ListItem sx={{ py: 1, px: 0 }}>
            <ListItemText primary='Total' />
            <Typography variant='subtitle1' sx={{ fontWeight: 700 }}>
              {`$${total}`}
            </Typography>
          </ListItem>
        </List>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Typography variant='primary' gutterBottom>
          Order summary
        </Typography>
        <List disablePadding>
          {products.map((product) => (
            <ListItem key={product.name} sx={{ py: 1, px: 0 }}>
              <ListItemText primary={product.name} secondary={product.type} />
              <Typography variant='body2'>{product.price}</Typography>
            </ListItem>
          ))}
          <ListItem sx={{ py: 1, px: 0 }}>
            <ListItemText primary='Total' />
            <Typography variant='subtitle1' sx={{ fontWeight: 700 }}>
              {`$${total}`}
            </Typography>
          </ListItem>
        </List>
      </React.Fragment>
    );
  }
}
